import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_474 implements Validator {

    public static id = 'CTRL_474';
    private message = 'error.ctr_474';


    public LOG: LogService = new LogService(CTRL_474);


    validate(form: any, map) {

        // TODO : TOFIX this control

        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_474.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const firstCtrl = form.controls[firstNameWithStepId];
                const secondCtrl = form.controls[secondNameWithStepId];
                if (firstCtrl.value && secondCtrl.value) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}




